/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:30
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-08-26 14:49:42
 * @FilePath: \baishu_react_ui\src\components\BsyScroll\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from "react";
import "./index.css";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from "../../utils/Utils";
import BsyCheckBox from "../BsyCheckBox";
import BsyTree, { getParentPath } from ".";

export default class BsyTreeSeach extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeRootNode: props.treeRootNode,
      treeParentNode: props.treeParentNode,
      treeNode: props.treeNode,
      treeTitle: props.treeTitle,
      filter: props.filter,
      multi: props.multi || false, // 是否多选
      openNodes: [props.treeRootNode],
      lastNodeSelect: true, // 是否选择最后一级节点
      onSelectData: props.onSelectData,
      nowNode: props.treeRootNode || "root",
      loading: false,
      nodes: [],
      value: [],
      seachList: [],
    };
    this.input = React.createRef();
    this.nodeData = {}; // 所有节点数据
    this.treeNode = {}; // 每次查询会重新清空
  }

  componentDidMount = () => {
    this.props?.getContext?.(this);
  };

  // 搜索节点的值
  loadData = (node, cb) => {
    let that = this;
    BsyUtils.forEach(this.nodeData, (key, it) => {
      if (that.nodeData[key].isRead) delete that.nodeData[key].isRead;
    });
    if (this.props.onGetData) {
      this.setState({
        loading: true,
      });
      this.props.onGetData(node, (data) => {
        if (Array.isArray(data)) {
          this.treeNode = {};
          data.map((it) => {
            this.nodeData[it.key] = { ...it };
          });
          this.setState({
            seachList: data,
          });
        }
        this.setState(
          {
            loading: false,
          },
          () => {
            cb && cb();
          }
        );
      });
    }
  };

  // 同步可以展开的节点中的值
  rsyncTreeNodeValue = () => {
    const { value, multi } = this.state;
    const { onChangeData } = this.props;
    const that = this;
    onChangeData?.(value);
    if (!multi) {
      return;
    }
    BsyUtils.forEach(this.treeNode, (key, context) => {
      context.setState({
        value: value,
      });
      that.nodeData = {
        ...that.nodeData,
        ...context.nodeData,
      };
    });
  };

  setValue = (val, isDel) => {
    const { value } = this.state;

    if (isDel) {
      this.setState(
        {
          value: value.filter((it) => {
            return it !== val;
          }),
        },
        () => {
          this.rsyncTreeNodeValue();

          // console.log("setValue", this.state.value);
        }
      );
    } else {
      this.setState({ value: [...value, val] }, () => {
        this.rsyncTreeNodeValue();
      });
    }
  };

  _getCheckData = () => {
    return this.getValue();
  };

  getValue = () => {
    const { value } = this.state;
    return value.map((it) => {
      return this.nodeData[it].data;
    });
  };

  renderRoot = (element) => {
    const { multi, value, treeParentNode, treeNode, treeTitle } = this.state;
    if (!element.children || element.children.length === 0) {
      return (
        <div className="bsy-tree-node" key={`root-${element.key}`}>
          <div
            className="node-title last-node"
            onClick={(e) => {
              if (multi) {
                this.setValue(
                  element.key,
                  this.state.value.includes(element.key)
                );
                return;
              }
              this.props.onSelectData(element.data);
            }}
          >
            {multi ? (
              <BsyCheckBox
                key={BsyUtils.getRandomCode(10)}
                text=""
                value={value.includes(element.key)}
                onChange={(e) => {
                  this.setValue(element.key, !e);
                }}
              />
            ) : (
              ""
            )}
            <span className="node-title-text">
              {element.title}
              <span className="parent-path">
                {getParentPath(element.parent_path || [])}
              </span>
            </span>
          </div>
        </div>
      );
    }
    return (
      <BsyTree
        getContext={(context) => {
          this.getContext(context, element.key);
        }}
        mode="seach"
        multi={multi}
        treeRootNode={element.key}
        treeParentNode={treeParentNode}
        treeNode={treeNode}
        treeTitle={treeTitle}
        openNodes={[]}
        key={`root-${element.key}`}
        onChangeData={(val, _val, isdel) => {
          if (isdel) {
            this.setState(
              {
                value: this.state.value.filter((it) => {
                  if (Array.isArray(_val)) {
                    return !_val.includes(it);
                  }
                  return it !== _val;
                }),
              },
              () => {
                this.rsyncTreeNodeValue();
              }
            );
          } else {
            const val_ = BsyUtils.arrayUnique([...val, ...this.state.value]);
            this.setState(
              {
                value: val_,
              },
              () => {
                this.rsyncTreeNodeValue();
              }
            );
          }
        }}
        onGetData={(node, cb) => {
          if (
            this.nodeData[node.nodeId] &&
            this.nodeData[node.nodeId].children &&
            this.nodeData[node.nodeId].children.length &&
            this.nodeData[node.nodeId].children[0].data !== "has"
          ) {
            cb(this.nodeData[node.nodeId]);
          } else {
            if (this.props.onGetData) {
              this.props.onGetData(node, (data) => {
                if (!BsyUtils.isObjectEmpty(data)) {
                  this.nodeData[node.nodeId] = {
                    ...(this.nodeData[data.key] ? this.nodeData[data.key] : {}),
                    ...data,
                  };
                  this.nodeData[node.nodeId].isRead = true;
                  if (data.children) {
                    data.children.map((it) => {
                      this.nodeData[it.key] = { ...it, parent: data.key };
                    });
                  }
                }
                cb(data);
              });
            }
          }
        }}
        onSelectData={this.props.onSelectData}
      />
    );
  };

  getContext = (context, key) => {
    this.treeNode[key] = context;
  };
  render() {
    const { style } = this.props;
    const { seachList, loading } = this.state;
    return (
      <>
        <div style={{ ...style }} className="tip2">
          {React.language("dataload.tree.tip2")}
        </div>
        <div
          className="bsy-tree-seach bsy-tree"
          ref={this.input}
          style={{ ...style }}
        >
          {loading ? (
            <BsySLoading mode="circling" />
          ) : seachList.length === 0 ? (
            <div className="bsy-tree-seach-empty">
              {React.language("address.seach.empty")}
            </div>
          ) : (
            seachList.map((it) => this.renderRoot(it))
          )}
        </div>
      </>
    );
  }
}
